// extracted by mini-css-extract-plugin
export default {"memoryLabel":"MemoryField_memoryLabel__dyIfj"};